import React from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import './DynamicFieldCheck.scss'
import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState
} from 'recoil'
import { modalCheckup } from '../../../recoil/state/modal'
import CheckItem from 'Components/CheckItem/CheckItem'
import DynamicFieldItem, {
  SECTION
} from 'Components/DynamicFiledItem/DynamicFieldItem'
import { notifyParent } from 'Helpers/notifyParent'
import { messageState } from 'Pages/OverviewMessage/recoil/state/message'
import { MESSAGE_STR_TYPE_CONTENTSCAMPAIGN } from 'Constants/'
import { sendingMessageCallback } from 'Pages/OverviewMessage/recoil/callbacks/callbacks'
import { modalNoEdit } from 'Pages/OverviewMessage/recoil/state/modal'
import { Link, LINK_VARIANT_EXTRALIGHT } from 'mailup-web-components'

const DynamicFieldCheck = () => {
  const intl = useIntl()
  const history = useHistory()
  const isSendingMessage = useRecoilCallback(sendingMessageCallback)
  const setModalNoEdit = useSetRecoilState(modalNoEdit)
  const [
    { dynamicFieldsOptionEnabled, wrongDynamicTags, addToWhiteList },
    setModalState
  ] = useRecoilState(modalCheckup)

  const { messageType, isBee, id, idCampaign } = useRecoilValue(messageState)

  const handleClick = (e, section) => {
    e.stopPropagation()
    e.preventDefault()
    switch (section) {
      case SECTION.body: {
        isSendingMessage(id).then(isSending => {
          if (!isSending) {
            if (isBee && messageType === MESSAGE_STR_TYPE_CONTENTSCAMPAIGN) {
              notifyParent('redirectMainFrame', [
                `App.aspx#/beePluginEditor/editCMP/${idCampaign}`
              ])
            }
            if (isBee && messageType !== MESSAGE_STR_TYPE_CONTENTSCAMPAIGN) {
              history.push(`/messages/email/bee/edit/${id}`)
            }
            if (!isBee) {
              notifyParent('redirectMainFrame', [
                `form_upd_newsletter.aspx?source=listemail&idNL=${id}`
              ])
            }
          } else {
            setModalState(prev => ({
              ...prev,
              show: false
            }))
            setModalNoEdit(true)
          }
        })
        break
      }
      case SECTION.subject || SECTION.preheader:
        setModalState(prev => ({
          ...prev,
          show: false
        }))
        break
      default:
        break
    }
  }

  const wrongDynamicTagsGroup =
    wrongDynamicTags &&
    wrongDynamicTags.reduce((a, item) => {
      a[item.Location] = a[item.Location] || []
      a[item.Location].push(item)
      return a
    }, Object.create(null))

  const dynamicFieldPreheader = wrongDynamicTagsGroup &&
    'Preheader' in wrongDynamicTagsGroup && (
      <DynamicFieldItem
        section={SECTION.preheader}
        items={wrongDynamicTagsGroup.Preheader}
        intl={intl}
        badge={
          !dynamicFieldsOptionEnabled
            ? intl.formatMessage({
                id: 'Load.EmailCheckUp.WarningLabel'
              })
            : ''
        }
        icon={!dynamicFieldsOptionEnabled ? 'alert' : ''}
        title={intl.formatMessage({
          id: 'Load.EmailCheckUp.SecntionDynamicFields'
        })}
        description={intl.formatMessage(
          {
            id: 'Load.EmailCheckUp.DynamicFieldsSummaryTitleIntl'
          },
          {
            link: e => (
              <Link
                variant={LINK_VARIANT_EXTRALIGHT}
                key={1}
                onClick={e => handleClick(e, SECTION.preheader)}
              >
                {e}
              </Link>
            )
          }
        )}
        setModalState={setModalState}
        addToWhiteList={addToWhiteList}
      />
    )

  const dynamicFieldSubject = wrongDynamicTagsGroup &&
    'Subject' in wrongDynamicTagsGroup && (
      <DynamicFieldItem
        section={SECTION.subject}
        items={wrongDynamicTagsGroup.Subject}
        intl={intl}
        badge={
          !dynamicFieldsOptionEnabled
            ? intl.formatMessage({
                id: 'Load.EmailCheckUp.WarningLabel'
              })
            : ''
        }
        icon={!dynamicFieldsOptionEnabled ? 'alert' : ''}
        title={
          'Preheader' in wrongDynamicTagsGroup
            ? ''
            : intl.formatMessage({
                id: 'Load.EmailCheckUp.SecntionDynamicFields'
              })
        }
        description={intl.formatMessage(
          {
            id: 'Load.EmailCheckUp.DynamicFieldsHeaderTitleIntl'
          },
          {
            link: e => (
              <Link
                variant={LINK_VARIANT_EXTRALIGHT}
                key={1}
                onClick={e => handleClick(e, SECTION.subject)}
              >
                {e}
              </Link>
            )
          }
        )}
        setModalState={setModalState}
        addToWhiteList={addToWhiteList}
      />
    )

  const dynamicFieldBody = wrongDynamicTagsGroup &&
    'Body' in wrongDynamicTagsGroup && (
      <DynamicFieldItem
        section={SECTION.body}
        items={wrongDynamicTagsGroup.Body}
        intl={intl}
        badge={
          !dynamicFieldsOptionEnabled
            ? intl.formatMessage({
                id: 'Load.EmailCheckUp.WarningLabel'
              })
            : ''
        }
        icon={!dynamicFieldsOptionEnabled ? 'alert' : ''}
        title={
          'Subject' in wrongDynamicTagsGroup ||
          'Preheader' in wrongDynamicTagsGroup
            ? ''
            : intl.formatMessage({
                id: 'Load.EmailCheckUp.SecntionDynamicFields'
              })
        }
        description={intl.formatMessage(
          {
            id: 'Load.EmailCheckUp.DynamicFieldsBodyTitleIntl'
          },
          {
            link: e => (
              <Link
                variant={LINK_VARIANT_EXTRALIGHT}
                key={1}
                onClick={e => handleClick(e, SECTION.body)}
              >
                {e}
              </Link>
            )
          }
        )}
        setModalState={setModalState}
        addToWhiteList={addToWhiteList}
      />
    )

  const handleClose = () => {
    setModalState(prev => ({
      ...prev,
      show: false
    }))
  }

  const propsOptionEnabled = () => ({
    itemKey: 'item-opt-enabled',
    icon: 'alert',
    badge: intl.formatMessage({
      id: 'Load.EmailCheckUp.WarningLabel'
    }),
    title: intl.formatMessage({
      id: 'Load.EmailCheckUp.DynamicFieldsOptDisabled'
    }),
    description: intl.formatMessage(
      {
        id: 'Load.EmailCheckUp.SummaryDynamicTagsAlert1Intl'
      },
      {
        link: e => (
          <Link
            variant={LINK_VARIANT_EXTRALIGHT}
            key='tag-alert-link'
            onClick={handleClose}
          >
            {e}
          </Link>
        ),
        br: <br key='tag-alert-br' />,
        strong: tokens => <strong key='tag-alert-strong'>{tokens}</strong>
      }
    )
  })

  return (
    <div className='c-dynamic-field-check'>
      {dynamicFieldsOptionEnabled && <CheckItem {...propsOptionEnabled()} />}
      {wrongDynamicTags && wrongDynamicTags.length > 0 && (
        <>
          {dynamicFieldPreheader}
          {dynamicFieldSubject}
          {dynamicFieldBody}
        </>
      )}
    </div>
  )
}

export default DynamicFieldCheck
